import { HttpTrackingConfig } from "../../../ShellCommon/logger/http-interceptor";
import { ServiceDeskConfig } from "../../Startup/serviceDeskConfig";
import { ContextService } from "../context/context-service";

export interface AuditService {
  /** Records an action name for auditing purposes */
  recordAction(actionName: string): ng.IPromise<any>;
}

class AuditData {
  // tslint:disable:variable-name
  public Source = "ServiceDeskFramework";
  public Time: string;
  public Actor: string;
  public Action: string;
  // tslint:enable:variable-name

  constructor(agentEmail: string, action: string) {
    this.Actor = agentEmail;
    this.Action = action;
    this.Time = new Date().toISOString();
  }
}

export class AuditServiceImpl {
  // @ngInject
  constructor(
    private $http: ng.IHttpService,
    private contextService: ContextService,
    private sdConfig: ServiceDeskConfig
  ) {}

  recordAction(actionName: string): ng.IPromise<any> {
    let auditData = new AuditData(
      this.contextService.appContext.agentUpn || this.contextService.appContext.agentEmail,
      actionName
    );
    let config: HttpTrackingConfig = {
      dependencyName: "ServiceDesk.SDController",
      operationName: "Audit.Post",
      dependencyOperationName: "Audit.Post"
    };
    return this.$http.post(this.getAuditUrl(), auditData, config);
  }

  private getAuditUrl(): string {
    return this.sdConfig.sdBaseUrl + "customer/api/Audit";
  }
}
